import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { getAllTransfer } from "../../actions/transfer";
import { getAllLocationPlain } from "../../actions/warehouseAction";

import RenderTable from "./RenderTable";

import { Layout, Breadcrumb, Row, Col, Spin, Form, Input, Button, DatePicker, Select, Space } from "antd";
const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;

const ProductDetails = ({ getAllTransfer, Auth, getAllLocationPlain }) => {
  const [details, setdetails] = useState([]);
  const [locations, setLocations] = useState([]);
  const pageno = useRef(1);
  const page_size = useRef(15);
  const [reload, setReload] = useState(true);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({});
  const [form] = Form.useForm();

  useEffect(() => {
    getAllLocationPlain().then((result) => {
      if(result){
         setLocations(result);
      }
    });
  }, [getAllLocationPlain]);

  useEffect(() => {
    getAllTransfer(pageno.current, page_size.current, filters).then(function (result) {
      setLoading(true);
      // console.log(result);
      setdetails(result);
      setLoading(false);
    });
  }, [reload, filters]);

  const onFinish = (values) => {
    let newFilters = { ...values };
    if (values.dateRange && values.dateRange.length > 0) {
      newFilters.start = values.dateRange[0].format("YYYY-MM-DD");
      newFilters.end = values.dateRange[1].format("YYYY-MM-DD");
      delete newFilters.dateRange;
    }
    setFilters(newFilters);
    pageno.current = 1;
    setReload(!reload);
  };

  const handleReset = () => {
    form.resetFields();
    setFilters({});
    pageno.current = 1;
    setReload(!reload);
  };

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Transfer</Breadcrumb.Item>
        <Breadcrumb.Item>All</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ marginBottom: 16 }}
        >
            <Row gutter={16}>
                <Col span={4}>
                    <Form.Item name="search" label="Search">
                        <Input placeholder="Transfer Number" />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item name="dateRange" label="Date">
                        <RangePicker style={{ width: '100%' }} />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item name="source" label="Source">
                        <Select placeholder="Source Office" allowClear>
                            {locations.map((outlet) => (
                                <Option key={outlet.id} value={outlet.name}>{outlet.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item name="destance" label="Destination">
                        <Select placeholder="Destination Office" allowClear>
                            {locations.map((outlet) => (
                                <Option key={outlet.id} value={outlet.name}>{outlet.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item name="status" label="Status">
                        <Select placeholder="Select Status" allowClear style={{ width: '100%' }}>
                            <Option value="Processing">Processing</Option>
                            <Option value="Received">Received</Option>
                            <Option value="Returned">Returned</Option>
                        </Select>
                    </Form.Item>
                </Col>
              
                <Col span={4}>
                    <Form.Item label=" ">
                        <Space>
                            <Button type="primary" htmlType="submit">
                                Filter
                            </Button>
                            <Button onClick={handleReset}>
                                Reset
                            </Button>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
        {loading ? (
            <Spin size="large" style={{ display: "block", textAlign: "center", marginTop: "20%" }} />
          ) : (
          <RenderTable 
          details={details} 
          Auth={Auth}
          pageno={pageno}
          page_size={page_size}
          reload={reload}
          setReload={setReload}
          />
          )}
        </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, { getAllTransfer, getAllLocationPlain })(ProductDetails);
